import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

export const Landing: React.FunctionComponent = () => {
  const { user, isAuthenticated } = useAuth();
  const [isLoggedin, setIsLoggedin] = React.useState<boolean>(false);

  useEffect(() => {
    if (user && user.access_token && isAuthenticated) {
      setIsLoggedin(true);
    }
  }, [user, isAuthenticated]);

  if (isLoggedin) {
    return <Navigate to="/home" />;
  }

  return <Navigate to="/login" />;
};
